import React, { useState } from 'react';
import { ChevronDown } from 'lucide-react';

const faqs = [
  {
    question: "Do you buy homes in any condition?",
    answer: "Yes. Pacific Crest Properties considers homes in a wide range of conditions and provides tailored options based on your needs."
  },
  {
    question: "How quickly can I receive information about my property?",
    answer: "After submitting your property details, our team reviews them and responds in a timely manner with next steps."
  },
  {
    question: "Do you offer renovation services?",
    answer: "Yes. We provide renovation options including kitchens, bathrooms, flooring, and whole-home improvements."
  },
  {
    question: "What areas do you serve?",
    answer: "We work with homeowners throughout Los Angeles and many surrounding communities."
  }
];

const FAQ = () => {
  const [openIndex, setOpenIndex] = useState(null);

  const toggleFAQ = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section
      id="faq"
      className="section-padding relative grid-pattern"
      style={{ backgroundColor: '#1F3B60' }}
    >
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section header */}
        <div className="text-center mb-12">
          <span className="inline-block font-semibold text-xs tracking-[0.2em] uppercase mb-4 px-4 py-1.5 rounded-full" style={{ color: '#D6A94F', backgroundColor: 'rgba(214, 169, 79, 0.1)', border: '1px solid rgba(214, 169, 79, 0.2)' }}>
            FAQ
          </span>
          <h2 className="font-display font-bold text-3xl sm:text-4xl text-white mb-4">
            Frequently Asked Questions
          </h2>
          <div className="divider-gold mx-auto" />
        </div>

        {/* FAQ Items */}
        <div className="space-y-4">
          {faqs.map((faq, index) => (
            <div
              key={index}
              className="card-navy overflow-hidden transition-all duration-300"
            >
              <button
                onClick={() => toggleFAQ(index)}
                className="w-full px-6 py-5 flex items-center justify-between text-left hover:bg-white/5 transition-colors duration-300"
              >
                <h3 className="font-semibold text-lg text-white pr-4">
                  {faq.question}
                </h3>
                <div
                  className="flex-shrink-0 w-8 h-8 rounded-full flex items-center justify-center transition-all duration-300"
                  style={{ 
                    background: openIndex === index ? 'linear-gradient(135deg, #D6A94F, #E4C078)' : 'rgba(255, 255, 255, 0.1)',
                    transform: openIndex === index ? 'rotate(180deg)' : 'rotate(0deg)'
                  }}
                >
                  <ChevronDown 
                    className="w-5 h-5" 
                    style={{ color: openIndex === index ? '#1F3B60' : 'white' }}
                  />
                </div>
              </button>
              
              <div
                className={`overflow-hidden transition-all duration-300 ease-in-out ${
                  openIndex === index ? 'max-h-48 opacity-100' : 'max-h-0 opacity-0'
                }`}
              >
                <p className="px-6 pb-5 text-white/70 leading-relaxed">
                  {faq.answer}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FAQ;
